<mon-spinner [progress]="progress" class="mon-chart-dashboard">
    <div class="row justify-content-center">
        <div class="mt-6 w-100">
            <div class="charts-row">
                <div class="chart-left">
                    <mon-chart-doughnut
                                    [colors]="doughnutColors"
                                    [options]="doughnutOptions"
                                    [labels]="doughnutLabels"
                                    [data]="doughnutData">
                    </mon-chart-doughnut>
                </div>
                <div class="chart-right" *ngIf="verticalData">
                    <mon-vertical-score
                        [monChartValue]="verticalData.verticalAverage"
                        [monTitle]="verticalData.averageTitle"
                        [monTooltipText]="verticalData.tooltipText"
                        [monLabels]="verticalData.labels"
                        [monSize]="100"
                    ></mon-vertical-score>
                </div>
            </div>
        </div>
    </div>
    <div class="card-container">
        <ul class="list-group d-flex align-items-stretch flex-wrap">
            <li class="list-group-item inline-block-important py-0 pr-1 pl-2" *ngFor="let card of cards">
                <p class="pl-2 my-0 text-grey">
                    {{card.title}}
                    <span class="fas fa-question-circle"
                          *ngIf="card.tooltipTitle"
                          [ngbTooltip]="card.tooltipTitle"
                          placement="right"
                          container="body"
                    >
                    </span>
                </p>
                <span class="pl-2 font-size-1-5 font-weight-400 card-count">
                    {{card.issues | monNumber}}
                </span>
                <br/>
                <span class="pl-2"
                      *ngIf="isNumber(card.change)"
                      [ngClass]="{'text-grey': card.change === 0, 'text-danger': card.change! > 0, 'text-success': card.change! < 0}">
                    <span class="far font-size-0-9"
                          *ngIf="card.change !== 0"
                          [ngClass]="{'fa-long-arrow-down': card.change! < 0, 'fa-long-arrow-up': card.change! > 0}">
                    </span>
                    {{card.changePercentage | monNumber:'0.[00]'}}%
                </span>
            </li>
        </ul>
    </div>
    <mon-chart-line
        [emptyDataMessage]="'There is no historic data for this domain' | translate"
        [height]="'250'"
        [options]="lineOptions"
        [data]="lineData"
        [labels]="lineLabels"
        [series]="lineSeries"
        [colors]="lineColors || []"
        [override]="lineOverride"
        [progress]="progress">
    </mon-chart-line>
</mon-spinner>
